import React, { useEffect, useRef } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import usePagosLogic from "./hooks/usePagosLogic";
import PagosView from "./pages/PagosView";

export default function Pagos() {
  const logic = usePagosLogic();
  const { form } = logic;
  const { openModal } = form || {};
  const location = useLocation();
  const openedRef = useRef(new Set());

  useEffect(() => {
    const search = location?.search || "";
    if (!search) return;
    const params = new URLSearchParams(search);
    const rawId = params.get("matriculaId") || params.get("matricula_id");
    const matriculaId = rawId ? Number(rawId) : null;
    if (!matriculaId || Number.isNaN(matriculaId)) return;
    if (openedRef.current.has(matriculaId)) return;
    openedRef.current.add(matriculaId);
    const rawEstId = params.get("estudianteId") || params.get("estudiante_id");
    const estudianteId = rawEstId ? Number(rawEstId) : null;
    openModal?.({
      matricula_id: matriculaId,
      estudiante_id: estudianteId || undefined,
      lockMatricula: true,
      lockMonto: false,
    });
  }, [location?.search, openModal]);

  return (
    <Routes>
      <Route path="/" element={<PagosView {...logic} />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
